import { IPopupScope, PopupCtrl } from '../controllers/PopupCtrl';
import { Module } from '../Module';
import { Corner } from '../services/StackedElementsService';

Module.instance().directive('tbPopup', <any[]>[
  () => {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      template: '<div class="tb-popup"></div>',
      scope: {
        show: '=',
        positionCorner: '@',
        contentCorner: '@',
        getPositionElement: '=?'
      },
      controller: PopupCtrl,
      link: (scope: IPopupScope, element: JQuery, attributes: ng.IAttributes, controller: PopupCtrl) => {
        const popup = controller.popup;
        function cornerFromString(cornerString: string): Corner {
          switch (cornerString) {
            case 'tl': return Corner.TopLeft;
            case 'tr': return Corner.TopRight;
            case 'bl': return Corner.BottomLeft;
            case 'br': return Corner.BottomRight;
          }
        }
        scope.$watch('show', (show: boolean) => {
          if (popup) {
            if (show) {
              popup.show(cornerFromString(scope.positionCorner), cornerFromString(scope.contentCorner));
            } else {
              popup.hide();
            }
          }
        });

        element.on('$destroy', () => {
          if (popup) {
            popup.hide();
          }
        });
      }
    };
  }
]);
